import React from 'react';
import { Section } from './Section';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    id: 1,
    badge: 'BONO #1 — GRATIS CON TU ACCESO HOY',
    title: 'KIT DE ARRANQUE 24H: EMPIEZA HOY SIN PENSAR',
    subtitle: 'La guía rápida para arrancar tu protocolo sin confusión, sin estrés y sin perder tiempo.',
    image: 'https://cdn.magicpatterns.com/uploads/b7hLTHsW3BzfJxJ33FzSXj/Bono_1.png',
    setup: ['Hay un momento que casi todas vivimos después de comprar una guía.', 'Lo compramos con emoción. Lo descargamos. Lo abrimos.', 'Y entonces aparece la pregunta: "Sí, pero… ¿por dónde empiezo?"', 'Y ahí es donde muchas personas se quedan. No porque no quieran. Sino porque nadie les dio un punto de arranque claro.', 'Este bono existe para que eso no te pase a ti.'],
    valueText: ['El Kit de Arranque 24H te da exactamente lo que necesitas para empezar hoy mismo en menos de 10 minutos.', 'Sin releer el protocolo tres veces. Sin reorganizar toda tu cocina. Sin esperar al "momento perfecto".', 'Solo abres, sigues el orden y arrancas.'],
    bullets: ['Checklist de preparación para las primeras 24 horas', 'Revisión rápida de cocina en 5 minutos — sin complicaciones', 'Mapa simple de lo que haces antes, durante y después de tu primer día', 'Mini tracker para cerrar el día con claridad', 'Versión printable para tenerlo a mano sin estar mirando el celular', 'Incluye un plan de recuperación para cuando el día no salió perfecto'],
    closing: 'Este bono convierte la emoción de empezar en acción real desde el minuto uno.',
    realValue: '$17'
  }, {
    id: 2,
    badge: 'BONO #2 — GRATIS CON TU ACCESO HOY',
    title: 'LISTA EXPRESS DE SUPERMERCADO: COMPRA SIN DAR VUELTAS',
    subtitle: 'Todo lo que necesitas comprar — organizado, claro y listo para llevar a Walmart o Target hoy mismo.',
    image: 'https://cdn.magicpatterns.com/uploads/hZqWgx79XpjjwBDueKf5wT/Bono_2.png',
    setup: ['¿Sabes cuál es uno de los momentos más frustrantes cuando quieres hacer un cambio en tu alimentación?', 'Entrar al supermercado sin saber exactamente qué comprar.', 'Caminas por los pasillos. Tomas cosas. Las devuelves. Terminas comprando lo de siempre.', 'Y cuando llegas a casa, te das cuenta de que no tienes lo necesario para seguir el protocolo.', 'Empiezas a improvisar. Y ahí se rompe todo.'],
    valueText: ['Esta lista express elimina ese problema de raíz.', 'No tienes que pensar. No tienes que investigar. No tienes que gastar de más.', 'Entras al súper con la lista en mano, marcas lo que ya tienes, compras lo que te falta y en una sola vuelta tienes todo resuelto.', 'Diseñada específicamente para mujeres que viven en USA y compran en lugares como Walmart o Target.', 'Sin productos raros. Sin ingredientes difíciles de encontrar. Sin gastos extras.'],
    bullets: ['Lista maestra organizada por categorías — proteínas, vegetales, frutas y básicos', 'Plantilla "ya lo tengo / me falta" para no comprar lo que ya está en casa', 'Ruta express de compra para entrar y salir rápido', 'Regla anti-gasto para no llenarte de productos que no vas a usar', 'Checklist final para revisar antes de salir del súper', 'Versión móvil y printable incluidas'],
    closing: 'Este bono hace que el protocolo encaje con tu vida real, no con una versión ideal que no existe.',
    realValue: '$17'
  }, {
    id: 3,
    badge: 'BONO #3 — GRATIS CON TU ACCESO HOY',
    title: 'RESET NOCTURNO DE 5 MINUTOS',
    subtitle: 'El mini ritual para cerrar bien tu día, recuperar el control y no perder el hilo del protocolo aunque el día haya sido un caos.',
    image: 'https://cdn.magicpatterns.com/uploads/xzacukqjcr5NH4ufsaYA36/Bono_3.png',
    setup: ['La mayoría de las personas no fallan por lo que hacen en la mañana.', 'Fallan por lo que pasa en la noche.', 'Llegan cansadas. Sin estructura. Sin haber revisado nada.', 'Y al día siguiente amanecen improvisando otra vez sin recordar bien dónde dejaron el protocolo o qué se supone que toca hacer.', 'Y así, poco a poco, lo que empezó con mucha energía se va diluyendo.', 'No por falta de ganas. Sino por falta de un cierre.'],
    valueText: ['El Reset Nocturno de 5 Minutos es exactamente ese cierre.', 'Un ritual simple que puedes hacer acostada en tu cama, en el sofá o en la cocina antes de dormir.', 'Sin complicaciones. Sin escribir mucho. Sin sentirte como si tuvieras tarea.', 'En 5 minutos revisas lo que sí hiciste bien, identificas lo que te costó, dejas una mini acción lista para mañana y cierras el día sintiéndote en control.', 'No con culpa. No con frustración. Con claridad.'],
    bullets: ['Ritual de 5 minutos dividido en pasos simples y claros', 'Hoja de reflexión rápida para detectar patrones sin juzgarte', 'Tracker de 3 noches para ver tu progreso de un vistazo', 'Guía de recuperación para noches difíciles o días caóticos', 'Frase de cierre para soltar el día sin culpa', 'Versión printable y versión móvil incluidas'],
    closing: 'Este bono te ayuda a sostener el protocolo incluso cuando la vida no coopera.',
    realValue: '$17'
  }];
  const giftThemes = [{
    // Bono 1 — Rose / Red gift wrap
    sectionBg: 'bg-gradient-to-br from-rose-100 via-rose-50 to-pink-100',
    stripeColor: 'rgba(225, 29, 72, 0.08)',
    stripeColor2: 'rgba(244, 63, 94, 0.04)',
    ribbonBg: 'bg-rose-600',
    ribbonText: 'text-white',
    bowColor: 'text-rose-600',
    cardBorder: 'border-rose-300',
    tagBg: 'bg-rose-50'
  }, {
    // Bono 2 — Gold / Amber gift wrap
    sectionBg: 'bg-gradient-to-br from-amber-100 via-yellow-50 to-amber-100',
    stripeColor: 'rgba(180, 83, 9, 0.08)',
    stripeColor2: 'rgba(217, 119, 6, 0.04)',
    ribbonBg: 'bg-amber-600',
    ribbonText: 'text-white',
    bowColor: 'text-amber-600',
    cardBorder: 'border-amber-300',
    tagBg: 'bg-amber-50'
  }, {
    // Bono 3 — Emerald / Green gift wrap
    sectionBg: 'bg-gradient-to-br from-emerald-100 via-green-50 to-emerald-100',
    stripeColor: 'rgba(5, 105, 70, 0.08)',
    stripeColor2: 'rgba(16, 185, 129, 0.04)',
    ribbonBg: 'bg-emerald-700',
    ribbonText: 'text-white',
    bowColor: 'text-emerald-700',
    cardBorder: 'border-emerald-300',
    tagBg: 'bg-emerald-50'
  }];
  return <div className="flex flex-col" data-id="element-16">
      {/* Intro header */}
      <Section className="bg-cream pb-4 md:pb-8" data-id="element-17">
        <div className="text-center max-w-3xl mx-auto" data-id="element-18">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-forest font-bold mb-4" data-id="element-19">
            Además, hoy recibes estos bonos gratis
          </h2>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed" data-id="element-20">
            Estos bonos te ayudan a empezar más fácil y a seguir el reset con
            más claridad.
          </p>
        </div>
      </Section>

      {bonuses.map((bono, index) => {
      const theme = giftThemes[index % giftThemes.length];
      const wrappingStyle = {
        backgroundImage: `repeating-linear-gradient(45deg, ${theme.stripeColor} 0px, ${theme.stripeColor} 2px, transparent 2px, transparent 24px), repeating-linear-gradient(-45deg, ${theme.stripeColor2} 0px, ${theme.stripeColor2} 2px, transparent 2px, transparent 24px)`
      };
      return <Section key={bono.id} className={`${theme.sectionBg} relative overflow-hidden`} data-id="element-21">
            {/* Wrapping paper pattern overlay */}
            <div className="absolute inset-0 pointer-events-none" style={wrappingStyle} aria-hidden="true" data-id="element-22" />

            <div className="max-w-4xl mx-auto relative" data-id="element-23">
              {/* Gift card container with ribbon */}
              <div className={`relative bg-white/95 backdrop-blur rounded-3xl shadow-2xl border-2 ${theme.cardBorder} p-6 md:p-10 pt-14 md:pt-16`} data-id="element-24">
                {/* Ribbon banner across top */}
                <div className={`absolute -top-4 left-1/2 -translate-x-1/2 ${theme.ribbonBg} ${theme.ribbonText} px-8 py-2 rounded-lg shadow-lg flex items-center gap-2 font-bold uppercase tracking-wider text-sm md:text-base whitespace-nowrap`} data-id="element-25">
                  <Gift className="w-5 h-5" data-id="element-26" />
                  Regalo #{bono.id}
                </div>

                {/* Decorative bow/tape corners */}
                <div className={`absolute top-0 left-0 w-12 h-12 md:w-16 md:h-16 ${theme.ribbonBg} opacity-90`} style={{
              clipPath: 'polygon(0 0, 100% 0, 0 100%)'
            }} aria-hidden="true" data-id="element-27" />
                <div className={`absolute top-0 right-0 w-12 h-12 md:w-16 md:h-16 ${theme.ribbonBg} opacity-90`} style={{
              clipPath: 'polygon(100% 0, 100% 100%, 0 0)'
            }} aria-hidden="true" data-id="element-28" />

                {/* Original badge */}
                <div className="flex justify-center mb-8" data-id="element-29">
                  <div className="inline-flex items-center gap-3 bg-gold text-forest font-bold px-6 py-3 md:px-8 md:py-4 rounded-full text-lg md:text-2xl lg:text-3xl shadow-xl border-2 border-forest/10 uppercase tracking-wide text-center" data-id="element-30">
                    <Gift className="w-6 h-6 md:w-8 md:h-8 flex-shrink-0" data-id="element-31" />
                    {bono.badge}
                  </div>
                </div>

                <div className="flex justify-center mb-10" data-id="element-32">
                  <img src={bono.image} alt={bono.badge} className="w-full max-w-sm rounded-2xl shadow-2xl object-cover border-4 border-white" data-id="element-33" />
                </div>

                <div className="space-y-4 mb-8 text-gray-700 text-lg" data-id="element-34">
                  {bono.setup.map((p, i) => <p key={i} data-id="element-35">{p}</p>)}
                </div>

                <div className={`${theme.tagBg} p-6 rounded-xl border border-gold/20 shadow-sm mb-8`} data-id="element-36">
                  <div className="space-y-4 text-gray-800 text-lg font-medium mb-6" data-id="element-37">
                    {bono.valueText.map((p, i) => <p key={i} data-id="element-38">{p}</p>)}
                  </div>

                  <ul className="space-y-3" data-id="element-39">
                    {bono.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-40">
                        <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-41" />
                        <span className="text-gray-700" data-id="element-42">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                <p className="text-xl font-serif font-bold text-forest italic mb-6" data-id="element-43">
                  {bono.closing}
                </p>

                <div className="flex items-center justify-between bg-forest text-cream px-6 py-4 rounded-xl" data-id="element-44">
                  <span className="text-cream/70 line-through text-lg" data-id="element-45">
                    Valor real: {bono.realValue}
                  </span>
                  <span className="text-gold font-bold text-2xl" data-id="element-46">
                    Hoy: GRATIS
                  </span>
                </div>
              </div>
            </div>
          </Section>;
    })}
    </div>;
}